var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUtility = function SvgUtility(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#747474",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "CurrentColor",
    fillRule: "evenodd",
    d: "M15.482 13.077 8.908 1.692c-.344-.615-1.09-.615-1.435 0L.899 13.077c-.402.707 0 1.692.718 1.692h13.148c.717 0 1.148-.985.717-1.692m-7.292-.77c-.488 0-.86-.4-.86-.923s.372-.923.86-.923c.489 0 .862.4.862.923s-.373.923-.862.923m.862-2.769c0 .185-.115.308-.287.308H7.616c-.172 0-.287-.123-.287-.308v-4c0-.184.115-.308.287-.308h1.149c.172 0 .287.124.287.308z",
    clipRule: "evenodd"
  })));
};
export default SvgUtility;